module.exports = __webpack_public_path__ + "img/007-doctor.1c5e4770.png";